import { COVERGO_SAAS_DEV, COVERGO_ASIA_QA, COVERGO_GCP_ASIA_UAT } from "../consts.js"

export const prudential_dev = {
	"pru-studio.dev.asia.covergo.dev": {
		appConfig: {
			tenantId: "prudential_dev",
			appId: "covergo_crm"
		},
		envConfig: COVERGO_SAAS_DEV,
		fileSystem: {
			bucketName: "covergo-apse1-dev-prudential-dev"
		}
	}
}

export const prudential_qa = {
	"pru-studio.qa.asia.covergo.dev": {
		appConfig: {
			tenantId: "prudential_qa",
			appId: "covergo_crm"
		},
		envConfig: COVERGO_ASIA_QA,
		fileSystem: {
			bucketName: "covergo-apse1-qa-prudential-qa"
		}
	}
}

export const prudential_uat = {
	"pru-studio.uat.pru.asia.covergo.dev": {
		appConfig: {
			tenantId: "prudential_uat",
			appId: "covergo_crm"
		},
		envConfig: COVERGO_GCP_ASIA_UAT,
		fileSystem: {
			bucketName: "pru-uat"
		}
	}
}